import React from 'react';

import { observer } from 'mobx-react';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { Button } from '@bringg/react-components';

import { routesMonitoringPolling } from '../../utils/routes-monitoring-polling';
import useRouteMonitoringStore from '../../stores/helpers/use-route-monitoring-store';

const RefreshViewButton = () => {
	const { routesMonitoringStore } = useRouteMonitoringStore();

	return (
		<Button
			shape="circle"
			type="link"
			icon={<BringgIcon iconName={BringgFontIcons.Redo} />}
			onClick={() => {
				routesMonitoringPolling.force(routesMonitoringStore.refreshData);
			}}
			loading={routesMonitoringStore.refreshing}
			data-test-id="refresh-view"
		/>
	);
};

export default observer(RefreshViewButton);
